import merge from 'lodash/merge';

import config from '../../config';
import fetch from '../fetch';
import logger from '../logger';

const options = {
  entityName: 'campaignAnalytics',
  endpoint: `${config.apiUrl}/v1/optimization`,
  searchEndpoint: `${config.apiUrl}/v1/optimization`,
};

const campaignAnalyticsAPI = () => {
  const fetchTableauTicket = async (orgId) => {
    const getUrl = `${options.endpoint}/tableau/trusted_auth/${orgId}`;
    try {
      const response = await fetch(getUrl, {
        method: 'POST',
        fullResponse: true,
      });
      return response.text();
    } catch (error) {
      logger.logDebug(`Failed to fetch tableau ticket for ${orgId}`, error);
      throw error;
    }
  };

  return merge({},
    {
      fetchTableauTicket,
    });
};

export default campaignAnalyticsAPI;
